import { render, staticRenderFns } from "./agb.vue?vue&type=template&id=5178c1e4&"
import script from "./agb.vue?vue&type=script&lang=ts&"
export * from "./agb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5178c1e4')) {
      api.createRecord('5178c1e4', component.options)
    } else {
      api.reload('5178c1e4', component.options)
    }
    module.hot.accept("./agb.vue?vue&type=template&id=5178c1e4&", function () {
      api.rerender('5178c1e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/views/agb.vue"
export default component.exports